module.exports = __webpack_public_path__ + "img/resumes.fbcb60b6.svg";